export const SEARCH_TEXT = "searchText"

export const setSearchText = (text) => ({ type: SEARCH_TEXT, payload: text })